/**
 * Servicio para interactuar con la API de Escuelas
 * Este servicio implementa los métodos necesarios para gestionar las escuelas
 */
import axios from 'axios';

// URL base para los endpoints de la API de Escuelas
const BASE_URL = 'https://backend-master.vuemoon.site/api/v1/';

/**
 * Servicio de Escuelas
 */
const escuelasService = {
  /**
   * Obtiene todas las escuelas
   * @param {boolean} refresh - Indica si se debe forzar la recarga de datos
   * @returns {Promise} - Promesa con la lista de escuelas
   */
  getEscuelas() {
    return axios.get(`${BASE_URL}lugares/get/lugares`);
  },

  /**
   * Obtiene una escuela por su ID
   * @param {number} id - ID de la escuela
   * @returns {Promise} - Promesa con los datos de la escuela
   */
  getEscuelaById(id) {
    return axios.get(`${BASE_URL}lugares/get/lugar`, { params: { id } });
  },

  /**
   * Crea una nueva escuela
   * @param {Object} escuela - Datos de la escuela
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  createEscuela(escuela) {
    return axios.post(`${BASE_URL}lugares/create/lugar`, escuela);
  },

  /**
   * Actualiza una escuela existente
   * @param {Object} escuela - Datos de la escuela con ID
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  updateEscuela(escuela) {
    return axios.put(`${BASE_URL}lugares/update/lugar`, escuela);
  },

  /**
   * Elimina una escuela
   * @param {number} id - ID de la escuela
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  deleteEscuela(id) {
    return axios.delete(`${BASE_URL}lugares/delete/lugar`, { params: { id } });
  }
};

export default escuelasService;
